// Modal.jsx
import { FaTimes } from "react-icons/fa";

const PageTableStatusModal = ({ show, title, onClose, children, maxWidth = "max-w-2xl" }) =>
  show ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className={`bg-white rounded-lg p-6 ${maxWidth} w-full max-h-[80vh] overflow-y-auto`}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium">{title}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <FaTimes size={25} />
          </button>
        </div>
        {children}
      </div>
    </div>
  ) : null;

export default PageTableStatusModal;